import { Award } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramCountryAward: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<Award> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/programs/${programId}/country-award`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Award>(fetchContext.errorStore, response, 'get program country award'));
